import templateUrl from './username-availability.component.html';

/**
 * Displays a username availability indicator (progress bar + a single rule),
 * mirroring the password strength component. The parent supplies the current
 * username, whether an availability check is in flight, and the latest result
 * of the duplication check (from the IsEmailAddressAvailable API).
 */
export const UsernameAvailabilityComponent = {
    templateUrl,
    bindings: {
        username: "<",
        available: "<",
        checking: "<"
    },
    controller: class UsernameAvailabilityComponent {
        $onChanges() {
            this.hasUsername = !!(this.username && String(this.username).trim());
            this.isSatisfied = !this.checking && this.hasUsername && !!this.available;
            // Keep the bar full whenever a username is entered so the colour
            // (info while checking / success / danger) is always visible; a 0-width
            // bar showed no red fill when the username was unavailable.
            this.availabilityStrength = this.hasUsername ? 100 : 0;
        }
    }
};
